module.exports = __webpack_public_path__ + "img/viewIcon.16c418d2.svg";